import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, AlertTriangle, Wrench, TrendingUp } from "lucide-react";
import { SectionHead } from "@/components/SectionHead";
import { Reveal } from "@/components/Reveal";

const CARDS = [
  { id: "cost-risk", icon: AlertTriangle, tag: "Cost Risk Detected", tone: "text-red-300", copy: "Maintenance expenditure increasing.", link: "View ANFORD Insight" },
  { id: "preventive", icon: Wrench, tag: "Preventive Action", tone: "text-gold-soft", copy: "Potential maintenance issue identified.", link: "See Recommendation" },
  { id: "opportunity", icon: TrendingUp, tag: "Portfolio Opportunity", tone: "text-emerald-300", copy: "Property outperforming portfolio benchmark.", link: "Explore Opportunity" },
];

export const InsightsTeaser = () => {
  const [active, setActive] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setActive((a) => (a + 1) % CARDS.length), 3200);
    return () => clearInterval(t);
  }, []);

  return (
    <section className="section relative overflow-hidden bg-navy-deep" data-testid="insights-teaser-section">
      <div className="pointer-events-none absolute -right-32 -top-32 h-96 w-96 rounded-full bg-gold/10 blur-3xl" aria-hidden="true" />
      <div className="container-x relative">
        <SectionHead dark eyebrow="ANFORD Insights" title="Your portfolio has more to tell you." copy="ANFORD Insights helps surface the risks, patterns and opportunities that deserve your attention." />
        <div className="mt-10 grid gap-4 md:mt-14 md:grid-cols-3 md:gap-6" data-testid="insight-teaser-cards">
          {CARDS.map((c, i) => (
            <Reveal key={c.id} delay={i * 0.08}>
              <Link
                to="/demo"
                data-testid={`insight-teaser-${c.id}`}
                onMouseEnter={() => setActive(i)}
                className={`flex h-full flex-col rounded-2xl border p-6 transition-[border-color,background-color,transform] duration-500 ${active === i ? "border-gold/60 bg-white/[0.1] -translate-y-1" : "border-white/10 bg-white/[0.05] hover:bg-white/[0.08]"}`}
              >
                <p className={`flex items-center gap-2 font-display text-[11px] font-bold uppercase tracking-[0.18em] ${c.tone}`}>
                  <c.icon className="h-3.5 w-3.5" /> {c.tag}
                </p>
                <p className="mt-4 flex-1 font-display text-lg font-bold leading-snug text-white">{c.copy}</p>
                <span className="mt-6 inline-flex items-center gap-1.5 font-display text-sm font-bold text-gold-soft">{c.link} <ArrowRight className="h-4 w-4" /></span>
              </Link>
            </Reveal>
          ))}
        </div>
        <Reveal className="mt-10 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-sm text-white/70">See what ANFORD could identify across your portfolio.</p>
          <Link to="/demo" data-testid="insights-teaser-demo-button" className="btn-gold w-full sm:w-auto">Book a Demo <ArrowRight className="h-4 w-4" /></Link>
        </Reveal>
      </div>
    </section>
  );
};
